'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isEqual = {};

exports.__exports = isEqual;
